import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Button, Flex, Text } from 'rebass';
import AnimatedContainer from './AnimatedContainer';
import Hide from './Hide';
import { Absolute } from './Position';

const EventRow = ({ event }) => {
  const isPastEvent = dayjs(event.date).isBefore(dayjs().subtract(1, 'day'));
  const isTicketsLinkDisabled = !event.ticketsUrl;
  const isEventLinkDisabled = !event.eventUrl;

  return (
    <AnimatedContainer>
      <Box
        css={{
          maxWidth: '1500px',
        }}
        mx="auto"
        px={[20, 30, 70]}
      >
        <Flex
          css={{
            borderTop: '1px solid black',
          }}
          flexWrap="wrap"
          pb={['25px', '25px', '40px']}
          pt={['10px', '10px', '15px']}
        >
          <Box width={['100%', '100%', 1 / 4]}>
            {event.artists.map((artist) => (
              <Text
                fontFamily="sans"
                fontSize={['18px', '18px', '19px']}
                mb={['5px', '5px', '10px']}
                key={artist}
              >
                {artist}
              </Text>
            ))}
          </Box>
          <Box mt={[15, 15, 0]} width={['100%', '100%', 1 / 4]}>
            <Text
              fontFamily="grot10"
              fontSize={['16px', '16px', '21px']}
              letterSpacing="-0.5px"
              lineHeight={['22px', '22px', '25px']}
            >
              @{event.place.name}
            </Text>
            <Text
              fontFamily="grot10"
              fontSize={['16px', '16px', '21px']}
              letterSpacing="-0.5px"
              lineHeight={['22px', '22px', '25px']}
            >
              {event.place.city}
            </Text>
          </Box>
          <Box mt={[10, 10, 0]} width={['100%', '100%', 1 / 4]}>
            <Text
              fontFamily="grot10"
              fontSize={['16px', '16px', '21px']}
              letterSpacing="-0.5px"
              lineHeight={['22px', '22px', '25px']}
            >
              {dayjs(event.date).format('dddd, MMMM D, YYYY')}
            </Text>
          </Box>
          <Flex
            alignItems="flex-start"
            css={{
              position: 'relative',
            }}
            flexDirection={['row-reverse', 'row-reverse', 'row']}
            justifyContent="flex-end"
            mt={['15px', '15px', '5px']}
            width={['100%', '100%', 1 / 4]}
          >
            {isPastEvent && (
              <Absolute
                bg="#FFEC00"
                css={{ transform: 'rotate(-30deg)', zIndex: 1 }}
                px="10px"
                right={['calc(50% - 30px)', 'calc(50% - 30px)', '140px']}
                top={['10px', '10px', '0']}
              >
                <Text
                  fontFamily="sans"
                  fontSize={['11px', '11px', '14px']}
                  lineHeight={['11px', '11px', '25px']}
                  py={['5px', '5px', 0]}
                >
                  PAST
                </Text>
              </Absolute>
            )}
            <Hide
              css={{ width: '100%' }}
              display={['block', 'block', 'none']}
              pl="5px"
            >
              <Button
                as="a"
                bg={
                  isPastEvent || isEventLinkDisabled
                    ? 'rgba(0,0,0,0.05)'
                    : 'black'
                }
                border="1px solid"
                borderColor={
                  isPastEvent || isEventLinkDisabled ? 'transparent' : 'black'
                }
                borderRadius={0}
                color={isPastEvent || isEventLinkDisabled ? 'black' : 'white'}
                css={{
                  '&:hover': !isPastEvent &&
                    !isEventLinkDisabled && {
                      backgroundColor: 'white',
                      color: 'black',
                      svg: {
                        marginRight: '7px',
                        width: '11px',
                      },
                    },
                  cursor:
                    isPastEvent || isEventLinkDisabled ? 'default' : 'pointer',
                  svg: {
                    transition: 'all 0.1s ease-in-out',
                  },
                  transition: 'all 0.1s ease-in-out',
                }}
                href={
                  isPastEvent || isEventLinkDisabled
                    ? undefined
                    : event.eventUrl
                }
                px="10px"
                py={0}
                rel="noopener noreferrer"
                target="_blank"
                width="100%"
              >
                <Text
                  opacity={isPastEvent || isEventLinkDisabled ? 0.25 : 1}
                  fontFamily="sans"
                  fontSize="11px"
                  lineHeight="14px"
                  py={12}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0"
                    height="10"
                    viewBox="0 0 11 10"
                  >
                    <path
                      fill="#000000"
                      fillRule="evenodd"
                      d="M7.45710678,4.45710678 L2.02512627,9.8890873 L0.610912703,8.47487373 L6.04289322,3.04289322 L3,0 L11,0 L11,8 L7.45710678,4.45710678 Z"
                    />
                  </svg>
                  EVENT
                </Text>
              </Button>
            </Hide>
            <Hide
              css={{ width: '100%' }}
              display={['block', 'block', 'none']}
              pr="5px"
            >
              <Button
                as="a"
                bg={
                  isPastEvent || isTicketsLinkDisabled
                    ? 'rgba(0,0,0,0.05)'
                    : 'white'
                }
                border="1px solid"
                borderColor={
                  isPastEvent || isTicketsLinkDisabled ? 'transparent' : 'black'
                }
                borderRadius={0}
                color="black"
                css={{
                  '&:hover': !isPastEvent &&
                    !isTicketsLinkDisabled && {
                      backgroundColor: 'black',
                      color: 'white',
                      svg: {
                        marginRight: '7px',
                        width: '11px',
                      },
                    },
                  cursor:
                    isPastEvent || isTicketsLinkDisabled
                      ? 'default'
                      : 'pointer',
                  svg: {
                    transition: 'all 0.1s ease-in-out',
                  },
                  transition: 'all 0.1s ease-in-out',
                }}
                disabled={isPastEvent || isTicketsLinkDisabled}
                href={
                  isPastEvent || isTicketsLinkDisabled
                    ? undefined
                    : event.ticketsUrl
                }
                px="10px"
                py={0}
                rel="noopener noreferrer"
                target="_blank"
                width="100%"
              >
                <Text
                  fontFamily="sans"
                  fontSize="11px"
                  opacity={isPastEvent || isTicketsLinkDisabled ? 0.25 : 1}
                  lineHeight="14px"
                  py={12}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0"
                    height="10"
                    viewBox="0 0 11 10"
                  >
                    <path
                      fill="#ffffff"
                      fillRule="evenodd"
                      d="M7.45710678,4.45710678 L2.02512627,9.8890873 L0.610912703,8.47487373 L6.04289322,3.04289322 L3,0 L11,0 L11,8 L7.45710678,4.45710678 Z"
                    />
                  </svg>
                  {isTicketsLinkDisabled && !isPastEvent ? 'FREE' : 'TICKETS'}
                </Text>
              </Button>
            </Hide>
            <Hide display={['none', 'none', 'block']} mr="10px">
              <Button
                as="a"
                bg={
                  isPastEvent || isEventLinkDisabled
                    ? 'rgba(0,0,0,0.05)'
                    : 'white'
                }
                border="1px solid"
                borderColor={
                  isPastEvent || isEventLinkDisabled ? 'transparent' : 'black'
                }
                borderRadius={0}
                color="black"
                css={{
                  '&:hover': !isPastEvent &&
                    !isEventLinkDisabled && {
                      backgroundColor: 'black',
                      color: 'white',
                      svg: {
                        marginRight: '7px',
                        width: '11px',
                      },
                    },
                  cursor:
                    isPastEvent || isEventLinkDisabled ? 'default' : 'pointer',
                  svg: {
                    transition: 'all 0.1s ease-in-out',
                  },
                  transition: 'all 0.1s ease-in-out',
                }}
                href={
                  isPastEvent || isEventLinkDisabled
                    ? undefined
                    : event.eventUrl
                }
                ml={0}
                px="10px"
                py={0}
                rel="noopener noreferrer"
                target="_blank"
                width="auto"
              >
                <Text
                  fontFamily="sans"
                  fontSize="14px"
                  opacity={isPastEvent || isEventLinkDisabled ? 0.25 : 1}
                  lineHeight="30px"
                  py={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0"
                    height="10"
                    viewBox="0 0 11 10"
                  >
                    <path
                      fill="#ffffff"
                      fillRule="evenodd"
                      d="M7.45710678,4.45710678 L2.02512627,9.8890873 L0.610912703,8.47487373 L6.04289322,3.04289322 L3,0 L11,0 L11,8 L7.45710678,4.45710678 Z"
                    />
                  </svg>
                  EVENT
                </Text>
              </Button>
            </Hide>
            <Hide display={['none', 'none', 'block']}>
              <Button
                as="a"
                bg={
                  isPastEvent || isTicketsLinkDisabled
                    ? 'rgba(0,0,0,0.05)'
                    : 'black'
                }
                border="1px solid"
                borderColor={
                  isPastEvent || isTicketsLinkDisabled ? 'transparent' : 'black'
                }
                borderRadius={0}
                color={isPastEvent || isTicketsLinkDisabled ? 'black' : 'white'}
                css={{
                  '&:hover': !isPastEvent &&
                    !isTicketsLinkDisabled && {
                      backgroundColor: 'white',
                      color: 'black',
                      svg: {
                        marginRight: '7px',
                        width: '11px',
                      },
                    },
                  cursor:
                    isPastEvent || isTicketsLinkDisabled
                      ? 'default'
                      : 'pointer',
                  minWidth: '90px',
                  svg: {
                    transition: 'all 0.1s ease-in-out',
                  },
                  transition: 'all 0.1s ease-in-out',
                }}
                disabled={isPastEvent || isTicketsLinkDisabled}
                href={
                  isPastEvent || isTicketsLinkDisabled
                    ? undefined
                    : event.ticketsUrl
                }
                mr={0}
                px="10px"
                py={0}
                rel="noopener noreferrer"
                target="_blank"
                width="auto"
              >
                <Text
                  fontFamily="sans"
                  fontSize="14px"
                  opacity={isPastEvent || isTicketsLinkDisabled ? 0.25 : 1}
                  lineHeight="30px"
                  py={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0"
                    height="10"
                    viewBox="0 0 11 10"
                  >
                    <path
                      fill="#000000"
                      fillRule="evenodd"
                      d="M7.45710678,4.45710678 L2.02512627,9.8890873 L0.610912703,8.47487373 L6.04289322,3.04289322 L3,0 L11,0 L11,8 L7.45710678,4.45710678 Z"
                    />
                  </svg>
                  {isTicketsLinkDisabled && !isPastEvent ? 'FREE' : 'TICKETS'}
                </Text>
              </Button>
            </Hide>
          </Flex>
        </Flex>
      </Box>
    </AnimatedContainer>
  );
};

EventRow.propTypes = {
  event: PropTypes.shape({
    artists: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
    date: PropTypes.string.isRequired,
    eventUrl: PropTypes.string,
    place: PropTypes.shape({
      city: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    ticketsUrl: PropTypes.string,
  }).isRequired,
};

export default EventRow;
